// export const url = 'https://klemensson.weloveit.se'
// export const image = 'https://klemensson.weloveit.se/static/images/og-logo.png'
export const titleTemplate = 'Bröderna Klemensson Fjällkött'
export const url = 'https://fjallkott.se'
export const image = 'https://fjallkott/static/images/og-logo.png'



// WEBPACK FOOTER //
// ./src/meta/metaConfig.js